import { REACT_APP_IMAGE_BASE_URL } from '../env';

/**
 * 动态创建字体 CSS 规则并预加载字体文件
 * 在应用启动时根据环境变量动态生成 @font-face 规则，并预加载关键字体
 */
export const initFontBaseUrl = () => {
  const fontBaseUrl = REACT_APP_IMAGE_BASE_URL;

  // 定义字体配置
  const fonts = [
    {
      family: 'D-DIN',
      files: [
        { url: `${fontBaseUrl}/ss/app/image/privateMvp/font/D-DIN.woff2`, format: 'woff2' },
        { url: `${fontBaseUrl}/ss/app/image/privateMvp/font/D-DIN.woff`, format: 'woff' },
        { url: `${fontBaseUrl}/ss/app/image/privateMvp/font/D-DIN.ttf`, format: 'truetype' }
      ],
      preload: false // 标记为需要预加载的关键字体
    },
    {
      family: 'D-DIN-Bold',
      files: [
        { url: `${fontBaseUrl}/ss/app/image/privateMvp/font/D-DIN-Bold.woff2`, format: 'woff2' },
        { url: `${fontBaseUrl}/ss/app/image/privateMvp/font/D-DIN-Bold.woff`, format: 'woff' },
        { url: `${fontBaseUrl}/ss/app/image/privateMvp/font/D-DIN-Bold.ttf`, format: 'truetype' }
      ],
      preload: false
    },
    {
      family: 'AlimamaShuHeiTi',
      files: [
        { url: `${fontBaseUrl}/ss/app/image/privateMvp/font/AlimamaShuHeiTi-Bold.woff`, format: 'woff' },
        { url: `${fontBaseUrl}/ss/app/image/privateMvp/font/AlimamaShuHeiTi-Bold.ttf`, format: 'truetype' }
      ],
      preload: false
    },
    {
      family: 'Montserrat',
      files: [
        { url: `${fontBaseUrl}/ss/app/image/privateMvp/font/Montserrat.woff`, format: 'woff' },
        { url: `${fontBaseUrl}/ss/app/image/privateMvp/font/Montserrat.ttf`, format: 'truetype' }
      ],
      preload: true
    }
  ];

  // 1. 首先添加字体预加载链接（最高优先级格式）
  fonts.forEach(font => {
    if (font.preload && font.files.length > 0) {
      // 优先加载 woff2 格式
      const preferredFile = font.files.find(file => file.format === 'woff2') || font.files[0];

      const linkElement = document.createElement('link');
      linkElement.rel = 'preload';
      linkElement.as = 'font';
      linkElement.type = 'font/woff2';
      linkElement.href = preferredFile.url;
      linkElement.crossOrigin = 'anonymous'; // 字体通常需要 CORS
      document.head.appendChild(linkElement);
    }
  });

  // 2. 生成字体 CSS（添加 font-display: swap 减少闪动）
  const fontCss = fonts.map(font => {
    const srcList = font.files.map(file => `url("${file.url}") format("${file.format}")`).join(',\n  ');

    return `@font-face {
  font-family: ${font.family};
  src: ${srcList};
  font-display: swap;
}`;
  }).join('\n\n');

  // 3. 创建 style 元素并插入到 head 中
  const styleElement = document.createElement('style');
  styleElement.id = 'dynamic-fonts';
  styleElement.textContent = fontCss;
  document.head.appendChild(styleElement);

  // 4. 可选：字体加载检测和回调
  if ('fonts' in document) {
    fonts.forEach(font => {
      document.fonts.load(`16px ${font.family}`).then(() => {
        console.log(`✅ 字体 ${font.family} 加载完成`);
      }).catch((error) => {
        console.warn(`⚠️ 字体 ${font.family} 加载失败:`, error);
      });
    });
  }

  console.log('🔤 字体CSS已动态生成，基础URL:', fontBaseUrl);
};

// 立即执行初始化
initFontBaseUrl();
